import { PasseriniAPI } from '@/services/apiService';
import type { CotizacionDolar } from '../types';

export const cotizacionService = {
  /**
   * Cotizaciones oficial, MEP y blue. El backend las consulta en una API
   * externa; si falla o tarda, responde con error.
   */
  getCotizacionesDolar: async (): Promise<CotizacionDolar[]> => {
    const response = await PasseriniAPI.get('/cotizaciones/dolar');
    return response.data.cotizaciones;
  },
};
